<template>
<q-dialog class="dialog" ref="dialog">
  <q-card>
    <common-form :action="formRoute" @submit.prevent="doSubmit">
      <input type="hidden" name="rule_version_id" :value="ruleVersion.id" />

      <q-card-section class="row items-center" :class="{'q-px-lg': $isDesktop}">
        <div class="heading-3 q-mr-sm">{{ ruleVersion.rule.code }}</div>
        <q-space />
        <icon-button icon="close" aria-label="Sluit dialoogvenster" size="sm" round v-close-popup />
      </q-card-section>
      <q-card-section class="dialog__messages" :class="$isMobile ? 'q-pb-none' : 'q-px-lg q-pt-none q-pb-sm'">
        <p v-if="isApprove">
          <template v-if="$can('approve', ruleVersion.rule)">
            Weet u zeker dat u deze richtlijn wilt goedkeuren? Laat direct een bericht achter met de reden hiervoor.
          </template>
          <template v-else>
            Weet u zeker dat u deze richtlijn wilt makeren als voldaan? Laat direct een bericht achter met de reden
            hiervoor.
          </template>
        </p>
        <p v-else>
          <template v-if="$can('approve', ruleVersion.rule)">
            Weet u zeker dat u deze richtlijn wilt afkeuren? Laat direct een bericht achter met de reden hiervoor.
          </template>
          <template v-else>
            Weet u zeker dat u deze richtlijn wilt makeren als afwijking? Laat direct een bericht achter met de reden
            hiervoor.
          </template>
        </p>
      </q-card-section>
      <q-card-section class="dialog__form">
        <common-input name="reason"
                      v-model="form.reason"
                      :label="isApprove ? 'Reden voor goedkeuring' : 'Reden voor afkeuring' "
                      type="textarea"
                      :error-message="$errorMessage('reason')"
                      :error="$hasError('reason')"
                      autofocus
        />
      </q-card-section>
      <q-separator />
      <q-card-actions :class="$isMobile ? 'q-pa-md' : 'q-px-lg q-py-md'">
        <accent-button
            label="Opslaan"
            type="submit"
        />
        <flat-button
            label="Annuleren"
            v-close-popup
        />
      </q-card-actions>
    </common-form>
  </q-card>
</q-dialog>
</template>

<script>
import { useProjectRules } from '../../../../stores/useProjectRules'
import { useProjectComents } from '../../../../stores/useProjectComments'

export default {
  setup () {
    const projectRules = useProjectRules()
    const projectComents = useProjectComents()
    return {
      projectRules,
      projectComents,
    }
  },
  props: {
    ruleVersion: {
      type: Object,
      default: null,
    },
    isApprove: {
      type: Boolean,
      required: false,
    },
    projectId: {
      type: Number,
      required: true,
    },
  },
  data () {
    return {
      form: {
        reason: '',
      },
    }
  },
  methods: {
    async doSubmit () {
      try {
        const response = await axios.post(
            this.formRoute, {
              rule_version_id: this.ruleVersion.id,
              reason: this.form.reason,
            },
        )
        this.projectRules.reload()
        this.projectComents.reload()
        this.$refs.dialog.hide()
        this.form.reason = ''
        this.$toast('success', response.data.message)
      } catch (e) {
        console.error(e)
        this.$refs.dialog.hide()
        this.$toast('error', 'De aanvraag kon niet worden uitgevoerd')
      }
    },
  },
  computed: {
    formRoute() {
      return route(this.isApprove ? 'project.rule.approve' : 'project.rule.reject', { project_id: this.projectId })
    },
  },
}
</script>
